import { create } from "zustand";

type TicketSoporteProps={
  isModalOpen: boolean;
  setIsModalOpen:(isOpen:boolean)=>void;

  tickets: any[];
  setTickets:(tickets: any[])=>void

  isModalSearchEnterOpen:boolean
  setIsModalSearchEnterOpen:(isOpen:boolean)=>void


  
}

export const useTicketModalStore = create<TicketSoporteProps>((set)=>({
  isModalOpen:false,
  tickets:[],
  isModalSearchEnterOpen:false,
  
  setIsModalOpen: (isopen)=>set({isModalOpen:isopen}),

  setTickets:(data)=>set({tickets:data}),

  setIsModalSearchEnterOpen(isOpen) {
    set({ isModalSearchEnterOpen: isOpen });
  },


}))
